import React from 'react';
import PropTypes from 'prop-types';
import { useSelect } from 'downshift';
import classNames from 'classnames';

import { SvgIcon } from '../../SvgIcon';

/**
 * @param {object} props - Props.
 * @param {string} props.label - Label.
 * @param {any[]} props.items - Items.
 * @param {Function} [props.itemToString] - Item to string.
 * @param {any} [props.initialSelectedItem] - Initial selected item.
 * @param {Function} [props.onSelectedItemChange] - On change callback.
 * @returns {JSX.Element} Component.
 */
export const SelectDesktop = ( props ) => {
    const {
        isOpen,
        selectedItem,
        getToggleButtonProps,
        getLabelProps,
        getMenuProps,
        highlightedIndex,
        getItemProps,
    } = useSelect( {
        items: props.items,
        initialSelectedItem: props.initialSelectedItem,
        // @ts-ignore
        onSelectedItemChange: props.onSelectedItemChange
    } );

    /**
     * @param {any} item - Item.
     * @returns {string} Text.
     */
    const getItemText = item => props.itemToString ? props.itemToString( item ) : item;

    return (
        <div
            className={ classNames( 'select', {
                'select--open': isOpen
            } ) }
        >
            <button
                type="button"
                { ...getToggleButtonProps() }
                className="select__display"
            >
                <label
                    { ...getLabelProps() }
                    className="select__label"
                >
                    { props.label }
                </label>
                <span className="select__current">
                    <span className="select__current-text">
                        { getItemText( selectedItem ) || '' }
                    </span>
                    
                    { isOpen ? (
                        <SvgIcon
                            className="select__close"
                            icon="close"
                        />
                    ) : (
                        <SvgIcon
                            className="select__chevron"
                            icon="chevron-down"
                        />
                    ) }
                </span>
            </button>
            <div className="select__options-wrapper">
                <ul
                    { ...getMenuProps() }
                    className={ classNames( 'select__options-list', {
                        'u-hide': !isOpen
                    } ) }
                >
                    { isOpen && props.items.map( ( item, index ) => {
                        const itemText = getItemText( item );
                        const isSelected = getItemText( selectedItem ) === itemText;

                        return (
                            <li
                                key={ `${ itemText }${ index }` }
                                { ...getItemProps( { item, index } ) }
                                className={ classNames( 'select__option', {
                                    'select__option--selected': isSelected,
                                    'select__option--highlighted': highlightedIndex === index,
                                } ) }
                            >
                                <span>{ itemText }</span>

                                { isSelected && (
                                    <SvgIcon
                                        icon="checkmark"
                                        className="select__option-button-icon"
                                    />
                                ) }
                            </li>
                        );
                    } ) }
                </ul>
            </div>
        </div>
    );
};

SelectDesktop.propTypes = {
    label: PropTypes.string.isRequired,
    items: PropTypes.arrayOf( PropTypes.any ),
    itemToString: PropTypes.func,
    initialSelectedItem: PropTypes.any,
    onSelectedItemChange: PropTypes.func
};
